<template>
  <div class="content-wrapper-form">
    <b-form
      class="form-signin"
      @submit.prevent="register"
      @keydown="registerForm.onKeydown($event)"
    >
      <div class="d-flex justify-content-around">
        <router-link :to="{ name: 'login' }" class="tab-dot"
          >Sign In</router-link
        >
        <router-link :to="{ name: 'register' }" class="tab-dot-active"
          >Sign Up</router-link
        >
      </div>

      <h2 class="mb-3 font-weight-bold text-center py-3">
        Which role describes <br />
        you best?
      </h2>

      <div class="roles-btn">
        <b-button
          class="btn btn-role"
          @click="registerForm.role = '2'"
          name="role"
          id="role-option1"
          autocomplete="off"
          value="2"
          v-model="registerForm.role"
          variant="outline-secondary"
          v-bind:class="{
            active: registerForm.role == 2,
          }"
        >
          Strata Manager
        </b-button>

        <b-button
          style=""
          class="btn btn-role"
          @click="registerForm.role = '3'"
          name="role"
          id="role-option2"
          autocomplete="off"
          value="3"
          v-model="registerForm.role"
          variant="outline-secondary"
          v-bind:class="{
            active: registerForm.role == 3,
          }"
        >
          Contractor
        </b-button>

        <has-error :form="registerForm" field="role" style="position: relative; top: -10px;"></has-error>
      </div>

      <div class="form-row">
        <b-form-group class="col">
          <b-form-input
            type="text"
            placeholder="First Name"
            v-model="registerForm.first_name"
            v-bind:class="{
              'is-invalid': registerForm.errors.has('first_name'),
            }"
          ></b-form-input>
          <has-error :form="registerForm" field="first_name"></has-error>
        </b-form-group>
        <b-form-group class="col">
          <b-form-input
            placeholder="Last Name"
            type="text"
            v-model="registerForm.last_name"
            v-bind:class="{
              'is-invalid': registerForm.errors.has('last_name'),
            }"
          ></b-form-input>
          <has-error :form="registerForm" field="last_name"></has-error>
        </b-form-group>
      </div>

      <b-form-group>
        <b-form-input
          placeholder="Email"
          v-model="registerForm.email"
          type="text"
          v-bind:class="{
            'is-invalid': registerForm.errors.has('email'),
          }"
        ></b-form-input>
        <has-error :form="registerForm" field="email"></has-error>
      </b-form-group>
      <b-form-group>
        <b-form-input
          placeholder="Mobile Number (04XX-XXX-XXX)"
          v-model="formattedPhone"
          type="text"
          v-bind:class="{
            'is-invalid': registerForm.errors.has('phone'),
          }"
          @keyup="formatPhone"
        ></b-form-input>
        <has-error :form="registerForm" field="phone"></has-error>
      </b-form-group>

      <b-form-group v-if="registerForm.sociallogin == false">
        <b-input-group class="mb-2 pwd-field">
          <b-form-input
            placeholder="Password"
            v-bind:type="showPassword ? 'text' : 'password'"
            v-model="registerForm.password"
            v-bind:class="{
              'is-invalid': registerForm.errors.has('password'),
            }"
          ></b-form-input>
          <b-input-group-append is-text @click="showPassword = !showPassword">
            <i
              v-if="showPassword"
              class="fa fa-eye-slash pwd-view"
              aria-hidden="true"
            ></i>
            <i v-else class="fa fa-eye pwd-view" aria-hidden="true"></i>
          </b-input-group-append>
        </b-input-group>

        <has-error :form="registerForm" field="password"></has-error>
      </b-form-group>

      <b-button
        :disabled="registerForm.busy"
        type="submit"
        variant="primary"
        class="btn-grad mx-auto signup-btn"
        >Sign Up
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { Form, HasError } from "vform";
import FooterComponent from "../../../pages/includes/FooterComponent.vue";
import phoneNoMixin from "../../../mixins/phoneNoMixin.js";

Vue.component(HasError.name, HasError);

export default {
  components: {
    FooterComponent,
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      subPage: "register",
      sociallogin: false,
      registerForm: new Form({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
        role: null,
        sociallogin: false,
        driver: "",
      }),
      formattedPhone: "",
      roles: [{ value: "2" }, { value: "3" }],
      showPassword: false,
    };
  },
  mounted() {
    if (this.$route.params.token) {
      this.getInvitedUserDetails();
    }

    if (Object.keys(this.$route.query).length > 0) {
      this.registerForm.sociallogin = true;
      this.registerForm.first_name = this.$route.query.firstname;
      this.registerForm.last_name = this.$route.query.lastname;
      this.registerForm.email = this.$route.query.email;
      this.registerForm.token = this.$route.query.token;
      this.registerForm.driver = this.$route.query.driver;
    }
  },
  methods: {
    getInvitedUserDetails() {
      axios
        .post("api/getInvitedUserDetails", {
          token: this.$route.params.token,
        })
        .then((response) => {
          this.registerForm.first_name = response.data.invited_member.first_name;
          this.registerForm.last_name = response.data.invited_member.last_name;
          this.registerForm.email = response.data.invited_member.email;
          this.registerForm.role = response.data.invited_member.user.role_id;
        });
    },
    register() {
        this.$root.$data.bsLoader = true;
        this.registerForm.post("register").then((response) => {
            this.$root.whoami();
            // this.$router.push({ name: "login" });
        }).catch((err) => {
            this.$root.$data.bsLoader = false;
        });
    },
    formatPhone() {
      this.registerForm.phone = this.getPhoneDigitsOnly(this.formattedPhone);
      this.formattedPhone = this.formatPhoneForAustralia(
        this.registerForm.phone
      );
    },
    changeSubpageTo(page) {
      this.subPage = page;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
    .form-signin br {
        display: none;
    }

    .form-signin h2 {
        font-size: 1.5rem;
    }
}
</style>
